// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-page {
    background-color: #fff;
    font-family: 'Noto Sans KR', sans-serif;
}

.cart-container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 60px 20px;
}

.co-progress-indicator {
    width: 466px;
    max-width: 100%;
    height: 90px;
    position: relative;
    margin: 40px auto;
    padding: 0;
}

.co-progress-line-bg {
    background: #d9d9d9;
    width: calc(100% - 25px);
    height: 3px;
    position: absolute;
    left: 25px;
    right: 0;
    top: 12px;
    z-index: 1;
}

.co-progress-line-fill {
    background: var(--primary, #e84200);
    width: 0;
    height: 3px;
    position: absolute;
    left: 25px;
    top: 12px;
    z-index: 2;
    transition: width 0.3s ease;
}

.co-progress-line-fill.step2 {
    width: calc(50% - 12.5px);
}

.co-progress-line-fill.step3 {
    width: calc(100% - 25px);
}

/* step-label 활성화 시 스타일 */
.co-progress-indicator .step-item.active .step-label {
    font-weight: 700;
    color: var(--primary, #e84200);
}

.co-progress-indicator .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    z-index: 3;
    width: auto;
    max-width: calc(33.333% - 10px);
    box-sizing: border-box;
}

/* step-item 순서: (3)견적서 만들기 왼쪽, (4)입력한 내용 확인 가운데, (5)견적 요청 완료 오른쪽 */
.co-progress-indicator .step-item:nth-child(3) {
    left: 12.5px;
    top: 0;
    transform: translateX(-50%);
}

.co-progress-indicator .step-item:nth-child(4) {
    left: 50%;
    transform: translateX(-50%);
    top: 0;
}

.co-progress-indicator .step-item:last-child {
    right: 12.5px;
    top: 0;
    transform: translateX(50%);
}

.step-dot {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: var(--grey2, #d9d9d9);
    flex-shrink: 0;
    position: relative;
    margin-bottom: 20px;
}

.co-progress-indicator .step-item.active .step-dot,
.step-dot.active {
    background: var(--primary, #e84200);
}

.step-label {
    color: var(--darkgrey3, #000000);
    text-align: center;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    white-space: normal;
    word-break: keep-all;
    max-width: 100%;
    overflow-wrap: break-word;
    width: 100%;
    min-width: 100px;
    display: block;
    margin: 0 auto;
}

.cart-main-content {
    /* Main content styles */
}

.quote-section {
    margin-bottom: 60px;
}

.quote-title {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
}

.cart-table {
    border-top: 2px solid #222;
}

.cart-table-header {
    display: flex;
    align-items: center;
    background-color: #f8f8f8;
    padding: 15px 0;
    font-weight: 500;
    border-bottom: 1px solid #ddd;
}

.header-cell {
    text-align: center;
}

.header-cell.checkbox { flex: 0 0 70px; }
.header-cell.product-info { flex: 1 1 auto; text-align: center;}
.header-cell.remarks { flex: 0 0 200px; }
.header-cell.quantity { flex: 0 0 180px; }
.header-cell.edit { flex: 0 0 200px; }


.cart-table-row {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #ddd;
}

.cell {
    text-align: center;
}

.cell.checkbox { flex: 0 0 70px; }
.cell.product-info { 
    flex: 1 1 auto; 
    display: flex;
    align-items: center;
}
.cell.remarks { flex: 0 0 200px; font-size: 14px; }
.cell.quantity { flex: 0 0 180px; }
.cell.edit { flex: 0 0 200px; }

.cart-item-image {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
    margin-right: 15px;
    flex-shrink: 0;
}
.cart-item-image.image-placeholder, .cart-item-image img {
    width: 80px;
    height: 60px;
    object-fit: cover;
}


.item-details {
    text-align: left;
}
.item-code {
    font-size: 14px;
    color: #888;
    margin: 0 0 5px 0;
}
.item-name {
    font-weight: 500;
    margin: 0 0 10px 0;
}
.item-plating {
    padding: 8px 12px;
    border-radius: 5px;
    border: 1px solid #ccc;
    min-width: 240px;
}
.quantity-selector {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.quantity-selector button {
    background: none;
    border: none;
    padding: 8px 15px;
    font-size: 18px;
    cursor: pointer;
    line-height: 1;
}

.quantity-selector span {
    padding: 0 15px;
    font-size: 16px;
    min-width: 50px;
    text-align: center;
}

.delete-item-btn {
    padding: 10px 20px;
    border: 1px solid #888;
    background-color: #fff;
    border-radius: 5px;
    cursor: pointer;
}

.delete-selected-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 20px;
    padding: 10px 20px;
    border: none;
    background-color: #222;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

.request-section {
    margin-bottom: 60px;
}

.request-title {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
}

.request-textarea {
    box-sizing: border-box;
    width: 100%;
    height: 150px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    resize: vertical;
}

.action-buttons {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin: 40px auto 0;
    max-width: 720px;
}

.action-buttons button {
    flex-basis: 350px;
    padding: 15px;
    border-radius: 5px;
    border: none;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.back-btn {
    background-color: #222;
    color: #fff;
}

.confirm-btn {
    background-color: #E84100;
    color: #fff;
}


.cart-table-header {
    padding: 15px;
}

.header-cell.product-info {
    text-align: center;
    padding-left: 0;
}
.header-cell.checkbox { flex-basis: 5%; }
.header-cell.product-info { flex-basis: 40%; }
.header-cell.remarks { flex-basis: 25%; }
.header-cell.quantity { flex-basis: 15%; }
.header-cell.edit { flex-basis: 15%; }

.cart-table-row {
    padding: 20px 15px;
}
.cell.checkbox { flex-basis: 5%; }
.cell.product-info { flex-basis: 40%;}
.cell.remarks { flex-basis: 25%;}
.cell.quantity { flex-basis: 15%;}
.cell.edit { flex-basis: 15%;}


/* Step 2: Confirmation Styles */

.cart-confirm-content {
    max-width: 900px;
    margin: 0 auto;
}

.confirm-info-section {
    text-align: center;
    margin-bottom: 60px;
}

.confirm-info-section h2 {
    font-size: 28px;
    font-weight: 500;
    margin: 0 0 10px 0;
}

.confirm-info-section p {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #333;
}

.confirm-info-section .info-text {
    color: #888;
    font-size: 14px;
}

.confirm-item-list {
    border-top: 2px solid #222;
    border-bottom: 2px solid #222;
}

/* 견적 요청 확인 단계의 이미지 스타일 수정 */
.confirm-item-image {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
    margin-right: 15px;
}

.confirm-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    gap: 15px;
}

.confirm-item:last-child {
    border-bottom: none;
}

.confirm-item-details {
    flex: 1 1;
    min-width: 0;
}

.confirm-item-details .item-code {
    font-size: 12px;
    color: #888;
    margin: 0 0 5px 0;
}

.confirm-item-details .item-name {
    font-weight: 500;
    margin: 0 0 5px 0;
    font-size: 14px;
}

.confirm-item-details .item-size,
.confirm-item-details .item-options {
    font-size: 12px;
    color: #666;
    margin: 0 0 3px 0;
}

.confirm-item-notes {
    max-width: 200px;
    font-size: 12px;
    color: #666;
    word-break: break-word;
}

.confirm-item-quantity {
    font-weight: 500;
    font-size: 14px;
    min-width: 60px;
    text-align: center;
}

.total-quantity-summary {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    padding: 30px 0;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 2px solid #222;
}

.total-quantity-summary .total-quantity {
    margin-left: 10px;
    font-size: 32px;
    color: #e84100;
}

.request-summary-section {
    margin-top: 40px;
    margin-bottom: 60px;
}

.request-summary-section .request-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 15px;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

.request-summary-text {
    padding: 15px;
    font-size: 16px;
    color: #333;
    line-height: 1.7;
    min-height: 50px;
}

.action-buttons button.black-btn {
    background-color: #222;
    color: white;
    flex-basis: auto;
    padding: 15px 40px;
}

.cart-complete-content {
    text-align: center;
    padding: 80px 0;
}

.complete-message-section {
    margin-bottom: 40px;
}

.complete-message-section h2 {
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 20px;
}

.complete-message-section p {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .cart-container {
        padding: 40px 15px;
    }

    .co-progress-indicator {
        max-width: 100%;
    }

    .cell.product-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .cart-container {
        padding: 20px 15px;
    }
    
    .co-progress-indicator {
        width: 100%;
        max-width: 100%;
        height: auto;
        min-height: 90px;
        margin: 40px auto;
        padding: 0 10px;
        box-sizing: border-box;
    }
    
    .co-progress-line-bg {
        width: calc(100% - 25px);
        left: 25px;
        right: 0;
    }
    
    .co-progress-line-fill {
        left: 25px;
    }
    
    .co-progress-line-fill.step2 {
        width: calc(50% - 12.5px);
    }
    
    .co-progress-line-fill.step3 {
        width: calc(100% - 25px);
    }
    
    .co-progress-indicator .step-item {
        max-width: calc(33.333% - 5px);
        padding: 0 5px;
        box-sizing: border-box;
    }

    .co-progress-indicator .step-item:nth-child(3) {
        left: 12.5px;
        transform: translateX(-50%);
    }
    
    .co-progress-indicator .step-item:nth-child(4) {
        left: 50%;
        transform: translateX(-50%);
    }
    
    .co-progress-indicator .step-item:last-child {
        right: 12.5px;
        transform: translateX(50%);
    }

    .step-label {
        font-size: 12px;
        line-height: 1.3;
        white-space: normal;
        word-break: keep-all;
        max-width: 100%;
        overflow-wrap: break-word;
        width: 100%;
        display: block;
        margin: 0 auto;
    }

    .cart-table-header {
        display: none;
    }

    .cart-table-row {
        flex-direction: column;
        gap: 15px;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        margin-bottom: 10px;
    }
    
    .cell {
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 5px 0;
    }
    
    .cell::before {
        content: attr(data-label);
        font-weight: bold;
        min-width: 80px;
    }
    
    .cell.checkbox {
       order: -1; /* Move checkbox to top */
       justify-content: flex-end;
    }
    .cell.checkbox::before {
        display: none;
    }
    
    .cell.product-info {
        flex-direction: column;
        align-items: center;
        gap: 15px;
        text-align: center;
    }
    .cell.product-info::before {
        display: none;
    }
    .item-details {
        text-align: center;
    }
    
    .action-buttons {
        flex-direction: column;
    }
    
    .confirm-item {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .confirm-item-notes {
        width: 100%;
        margin-top: 10px;
    }
}

/* 파일 첨부 섹션 스타일 */
.file-upload-section {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #eee;
    border-radius: 8px;
    background-color: #fafafa;
}

.file-upload-section .request-title {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.file-info {
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
}

.file-upload-btn {
    background-color: #E84100;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
}

.file-upload-btn:hover:not(:disabled) {
    background-color: #d63700;
}

.file-upload-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.uploaded-files {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #ddd;
}

.uploaded-files h4 {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.uploaded-file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 8px;
}

.file-name {
    font-size: 13px;
    color: #333;
    flex: 1 1;
    margin-right: 10px;
}

.file-size {
    font-size: 12px;
    color: #666;
    margin-right: 10px;
}

.remove-file-btn {
    background-color: #ff4757;
    color: white;
    border: none;
    padding: 4px 8px;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s ease;
}

.remove-file-btn:hover {
    background-color: #ff3742;
} `, "",{"version":3,"sources":["webpack://./src/pages/css/CartPage.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;IACI,YAAY;IACZ,MAAM;IACN,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,MAAM;AACV;;AAEA;IACI,aAAa;IACb,MAAM;IACN,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA,wBAAwB,cAAc,EAAE;AACxC,4BAA4B,cAAc,EAAE,kBAAkB,CAAC;AAC/D,uBAAuB,eAAe,EAAE;AACxC,wBAAwB,eAAe,EAAE;AACzC,oBAAoB,eAAe,EAAE;;;AAGrC;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA,iBAAiB,cAAc,EAAE;AACjC;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;AACA,gBAAgB,eAAe,EAAE,eAAe,EAAE;AAClD,iBAAiB,eAAe,EAAE;AAClC,aAAa,eAAe,EAAE;;AAE9B;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA,wBAAwB,cAAc,EAAE;AACxC,4BAA4B,eAAe,EAAE;AAC7C,uBAAuB,eAAe,EAAE;AACxC,wBAAwB,eAAe,EAAE;AACzC,oBAAoB,eAAe,EAAE;;AAErC;IACI,kBAAkB;AACtB;AACA,iBAAiB,cAAc,EAAE;AACjC,qBAAqB,eAAe,CAAC;AACrC,gBAAgB,eAAe,CAAC;AAChC,iBAAiB,eAAe,CAAC;AACjC,aAAa,eAAe,CAAC;;;AAG7B,gCAAgC;;AAEhC;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;QAC9B,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB,eAAe;QACf,yBAAyB;QACzB,WAAW;QACX,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;OACG,SAAS,EAAE,yBAAyB;OACpC,yBAAyB;IAC5B;IACA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".cart-page {\n    background-color: #fff;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.cart-container {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 60px 20px;\n}\n\n.co-progress-indicator {\n    width: 466px;\n    max-width: 100%;\n    height: 90px;\n    position: relative;\n    margin: 40px auto;\n    padding: 0;\n}\n\n.co-progress-line-bg {\n    background: #d9d9d9;\n    width: calc(100% - 25px);\n    height: 3px;\n    position: absolute;\n    left: 25px;\n    right: 0;\n    top: 12px;\n    z-index: 1;\n}\n\n.co-progress-line-fill {\n    background: var(--primary, #e84200);\n    width: 0;\n    height: 3px;\n    position: absolute;\n    left: 25px;\n    top: 12px;\n    z-index: 2;\n    transition: width 0.3s ease;\n}\n\n.co-progress-line-fill.step2 {\n    width: calc(50% - 12.5px);\n}\n\n.co-progress-line-fill.step3 {\n    width: calc(100% - 25px);\n}\n\n/* step-label 활성화 시 스타일 */\n.co-progress-indicator .step-item.active .step-label {\n    font-weight: 700;\n    color: var(--primary, #e84200);\n}\n\n.co-progress-indicator .step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: absolute;\n    z-index: 3;\n    width: auto;\n    max-width: calc(33.333% - 10px);\n    box-sizing: border-box;\n}\n\n/* step-item 순서: (3)견적서 만들기 왼쪽, (4)입력한 내용 확인 가운데, (5)견적 요청 완료 오른쪽 */\n.co-progress-indicator .step-item:nth-child(3) {\n    left: 12.5px;\n    top: 0;\n    transform: translateX(-50%);\n}\n\n.co-progress-indicator .step-item:nth-child(4) {\n    left: 50%;\n    transform: translateX(-50%);\n    top: 0;\n}\n\n.co-progress-indicator .step-item:last-child {\n    right: 12.5px;\n    top: 0;\n    transform: translateX(50%);\n}\n\n.step-dot {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background: var(--grey2, #d9d9d9);\n    flex-shrink: 0;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.co-progress-indicator .step-item.active .step-dot,\n.step-dot.active {\n    background: var(--primary, #e84200);\n}\n\n.step-label {\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    white-space: normal;\n    word-break: keep-all;\n    max-width: 100%;\n    overflow-wrap: break-word;\n    width: 100%;\n    min-width: 100px;\n    display: block;\n    margin: 0 auto;\n}\n\n.cart-main-content {\n    /* Main content styles */\n}\n\n.quote-section {\n    margin-bottom: 60px;\n}\n\n.quote-title {\n    font-size: 24px;\n    font-weight: 500;\n    margin-bottom: 20px;\n}\n\n.cart-table {\n    border-top: 2px solid #222;\n}\n\n.cart-table-header {\n    display: flex;\n    align-items: center;\n    background-color: #f8f8f8;\n    padding: 15px 0;\n    font-weight: 500;\n    border-bottom: 1px solid #ddd;\n}\n\n.header-cell {\n    text-align: center;\n}\n\n.header-cell.checkbox { flex: 0 0 70px; }\n.header-cell.product-info { flex: 1 1 auto; text-align: center;}\n.header-cell.remarks { flex: 0 0 200px; }\n.header-cell.quantity { flex: 0 0 180px; }\n.header-cell.edit { flex: 0 0 200px; }\n\n\n.cart-table-row {\n    display: flex;\n    align-items: center;\n    padding: 20px 0;\n    border-bottom: 1px solid #ddd;\n}\n\n.cell {\n    text-align: center;\n}\n\n.cell.checkbox { flex: 0 0 70px; }\n.cell.product-info { \n    flex: 1 1 auto; \n    display: flex;\n    align-items: center;\n}\n.cell.remarks { flex: 0 0 200px; font-size: 14px; }\n.cell.quantity { flex: 0 0 180px; }\n.cell.edit { flex: 0 0 200px; }\n\n.cart-item-image {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    margin-right: 15px;\n    flex-shrink: 0;\n}\n.cart-item-image.image-placeholder, .cart-item-image img {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n}\n\n\n.item-details {\n    text-align: left;\n}\n.item-code {\n    font-size: 14px;\n    color: #888;\n    margin: 0 0 5px 0;\n}\n.item-name {\n    font-weight: 500;\n    margin: 0 0 10px 0;\n}\n.item-plating {\n    padding: 8px 12px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    min-width: 240px;\n}\n.quantity-selector {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.quantity-selector button {\n    background: none;\n    border: none;\n    padding: 8px 15px;\n    font-size: 18px;\n    cursor: pointer;\n    line-height: 1;\n}\n\n.quantity-selector span {\n    padding: 0 15px;\n    font-size: 16px;\n    min-width: 50px;\n    text-align: center;\n}\n\n.delete-item-btn {\n    padding: 10px 20px;\n    border: 1px solid #888;\n    background-color: #fff;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.delete-selected-btn {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    margin-top: 20px;\n    padding: 10px 20px;\n    border: none;\n    background-color: #222;\n    color: #fff;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.request-section {\n    margin-bottom: 60px;\n}\n\n.request-title {\n    font-size: 24px;\n    font-weight: 500;\n    margin-bottom: 20px;\n}\n\n.request-textarea {\n    box-sizing: border-box;\n    width: 100%;\n    height: 150px;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 16px;\n    resize: vertical;\n}\n\n.action-buttons {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    margin: 40px auto 0;\n    max-width: 720px;\n}\n\n.action-buttons button {\n    flex-basis: 350px;\n    padding: 15px;\n    border-radius: 5px;\n    border: none;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.back-btn {\n    background-color: #222;\n    color: #fff;\n}\n\n.confirm-btn {\n    background-color: #E84100;\n    color: #fff;\n}\n\n\n.cart-table-header {\n    padding: 15px;\n}\n\n.header-cell.product-info {\n    text-align: center;\n    padding-left: 0;\n}\n.header-cell.checkbox { flex-basis: 5%; }\n.header-cell.product-info { flex-basis: 40%; }\n.header-cell.remarks { flex-basis: 25%; }\n.header-cell.quantity { flex-basis: 15%; }\n.header-cell.edit { flex-basis: 15%; }\n\n.cart-table-row {\n    padding: 20px 15px;\n}\n.cell.checkbox { flex-basis: 5%; }\n.cell.product-info { flex-basis: 40%;}\n.cell.remarks { flex-basis: 25%;}\n.cell.quantity { flex-basis: 15%;}\n.cell.edit { flex-basis: 15%;}\n\n\n/* Step 2: Confirmation Styles */\n\n.cart-confirm-content {\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n.confirm-info-section {\n    text-align: center;\n    margin-bottom: 60px;\n}\n\n.confirm-info-section h2 {\n    font-size: 28px;\n    font-weight: 500;\n    margin: 0 0 10px 0;\n}\n\n.confirm-info-section p {\n    margin: 0 0 10px 0;\n    font-size: 16px;\n    color: #333;\n}\n\n.confirm-info-section .info-text {\n    color: #888;\n    font-size: 14px;\n}\n\n.confirm-item-list {\n    border-top: 2px solid #222;\n    border-bottom: 2px solid #222;\n}\n\n/* 견적 요청 확인 단계의 이미지 스타일 수정 */\n.confirm-item-image {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    margin-right: 15px;\n}\n\n.confirm-item {\n    display: flex;\n    align-items: center;\n    padding: 15px 0;\n    border-bottom: 1px solid #eee;\n    gap: 15px;\n}\n\n.confirm-item:last-child {\n    border-bottom: none;\n}\n\n.confirm-item-details {\n    flex: 1;\n    min-width: 0;\n}\n\n.confirm-item-details .item-code {\n    font-size: 12px;\n    color: #888;\n    margin: 0 0 5px 0;\n}\n\n.confirm-item-details .item-name {\n    font-weight: 500;\n    margin: 0 0 5px 0;\n    font-size: 14px;\n}\n\n.confirm-item-details .item-size,\n.confirm-item-details .item-options {\n    font-size: 12px;\n    color: #666;\n    margin: 0 0 3px 0;\n}\n\n.confirm-item-notes {\n    max-width: 200px;\n    font-size: 12px;\n    color: #666;\n    word-break: break-word;\n}\n\n.confirm-item-quantity {\n    font-weight: 500;\n    font-size: 14px;\n    min-width: 60px;\n    text-align: center;\n}\n\n.total-quantity-summary {\n    display: flex;\n    justify-content: flex-end;\n    align-items: baseline;\n    padding: 30px 0;\n    font-size: 24px;\n    font-weight: 500;\n    border-bottom: 2px solid #222;\n}\n\n.total-quantity-summary .total-quantity {\n    margin-left: 10px;\n    font-size: 32px;\n    color: #e84100;\n}\n\n.request-summary-section {\n    margin-top: 40px;\n    margin-bottom: 60px;\n}\n\n.request-summary-section .request-title {\n    font-size: 20px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 15px;\n}\n\n.request-summary-text {\n    padding: 15px;\n    font-size: 16px;\n    color: #333;\n    line-height: 1.7;\n    min-height: 50px;\n}\n\n.action-buttons button.black-btn {\n    background-color: #222;\n    color: white;\n    flex-basis: auto;\n    padding: 15px 40px;\n}\n\n.cart-complete-content {\n    text-align: center;\n    padding: 80px 0;\n}\n\n.complete-message-section {\n    margin-bottom: 40px;\n}\n\n.complete-message-section h2 {\n    font-size: 28px;\n    font-weight: 500;\n    margin-bottom: 20px;\n}\n\n.complete-message-section p {\n    font-size: 16px;\n    color: #666;\n    line-height: 1.6;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .cart-container {\n        padding: 40px 15px;\n    }\n\n    .co-progress-indicator {\n        max-width: 100%;\n    }\n\n    .cell.product-info {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .cart-container {\n        padding: 20px 15px;\n    }\n    \n    .co-progress-indicator {\n        width: 100%;\n        max-width: 100%;\n        height: auto;\n        min-height: 90px;\n        margin: 40px auto;\n        padding: 0 10px;\n        box-sizing: border-box;\n    }\n    \n    .co-progress-line-bg {\n        width: calc(100% - 25px);\n        left: 25px;\n        right: 0;\n    }\n    \n    .co-progress-line-fill {\n        left: 25px;\n    }\n    \n    .co-progress-line-fill.step2 {\n        width: calc(50% - 12.5px);\n    }\n    \n    .co-progress-line-fill.step3 {\n        width: calc(100% - 25px);\n    }\n    \n    .co-progress-indicator .step-item {\n        max-width: calc(33.333% - 5px);\n        padding: 0 5px;\n        box-sizing: border-box;\n    }\n\n    .co-progress-indicator .step-item:nth-child(3) {\n        left: 12.5px;\n        transform: translateX(-50%);\n    }\n    \n    .co-progress-indicator .step-item:nth-child(4) {\n        left: 50%;\n        transform: translateX(-50%);\n    }\n    \n    .co-progress-indicator .step-item:last-child {\n        right: 12.5px;\n        transform: translateX(50%);\n    }\n\n    .step-label {\n        font-size: 12px;\n        line-height: 1.3;\n        white-space: normal;\n        word-break: keep-all;\n        max-width: 100%;\n        overflow-wrap: break-word;\n        width: 100%;\n        display: block;\n        margin: 0 auto;\n    }\n\n    .cart-table-header {\n        display: none;\n    }\n\n    .cart-table-row {\n        flex-direction: column;\n        gap: 15px;\n        padding: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        margin-bottom: 10px;\n    }\n    \n    .cell {\n        text-align: left;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        padding: 5px 0;\n    }\n    \n    .cell::before {\n        content: attr(data-label);\n        font-weight: bold;\n        min-width: 80px;\n    }\n    \n    .cell.checkbox {\n       order: -1; /* Move checkbox to top */\n       justify-content: flex-end;\n    }\n    .cell.checkbox::before {\n        display: none;\n    }\n    \n    .cell.product-info {\n        flex-direction: column;\n        align-items: center;\n        gap: 15px;\n        text-align: center;\n    }\n    .cell.product-info::before {\n        display: none;\n    }\n    .item-details {\n        text-align: center;\n    }\n    \n    .action-buttons {\n        flex-direction: column;\n    }\n    \n    .confirm-item {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .confirm-item-notes {\n        width: 100%;\n        margin-top: 10px;\n    }\n}\n\n/* 파일 첨부 섹션 스타일 */\n.file-upload-section {\n    margin-bottom: 30px;\n    padding: 20px;\n    border: 1px solid #eee;\n    border-radius: 8px;\n    background-color: #fafafa;\n}\n\n.file-upload-section .request-title {\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.file-info {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 15px;\n}\n\n.file-upload-btn {\n    background-color: #E84100;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s ease;\n}\n\n.file-upload-btn:hover:not(:disabled) {\n    background-color: #d63700;\n}\n\n.file-upload-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.uploaded-files {\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #ddd;\n}\n\n.uploaded-files h4 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.uploaded-file-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    background-color: white;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 8px;\n}\n\n.file-name {\n    font-size: 13px;\n    color: #333;\n    flex: 1;\n    margin-right: 10px;\n}\n\n.file-size {\n    font-size: 12px;\n    color: #666;\n    margin-right: 10px;\n}\n\n.remove-file-btn {\n    background-color: #ff4757;\n    color: white;\n    border: none;\n    padding: 4px 8px;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: background-color 0.3s ease;\n}\n\n.remove-file-btn:hover {\n    background-color: #ff3742;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
